import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import * as Types from "./types";

export const masterDataTimezoneListService = (
  params: Types.MasterDataTimezoneListRequest
) =>
  RestAPIClient.call<Types.MasterDataTimezoneListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const masterDataTimezoneListShortService = (
  params: Types.MasterDataTimezoneListRequest
) =>
  RestAPIClient.call<Types.MasterDataTimezoneListShortResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.ListShort,
    config: {
      requireAuthentication: true,
      params,
    },
  });
